<template>
  <v-flex xs12 class="flex-container-space-between vertical-center-container">
    <span class="vertical-center-container">
      <span class="headline">{{title}}</span>
      <span v-if="!!details" class="grey--text subheading px-2">-</span>
      <span v-if="!!details" class="grey--text subheading">{{details}}</span>
    </span>
    <span v-if="!!subtitle">{{subtitle}}</span>
    <span v-if="!!time" class="grey--text">
      <time-ago :time="time" needsParse updated></time-ago>
    </span>
    <v-btn v-if="!!closeButton" icon flat color="grey darken-1" @click="$emit('close')">
      <v-icon>close</v-icon>
    </v-btn>
  </v-flex>
</template>

<script>
export default {
  props: {
    title: String,
    details: String,
    subtitle: String,
    time: String,
    closeButton: Boolean
  }
}
</script>

<style>

</style>